import React, { FunctionComponent, createContext, useContext } from 'react';

export type MarkdownType = {
  classes?: {
    inlineCode?: string;
    image?: string;
  };
  widths?: {
    image?: string;
    video?: string;
  };
};

const MarkdownContext = createContext<MarkdownType>({
  classes: {},
  widths: {},
});
MarkdownContext.displayName = 'Markdown';

export function useMarkdown() {
  return useContext(MarkdownContext);
}

const MarkdownProvider: FunctionComponent<React.PropsWithChildren<MarkdownType>> = ({
  children,
  classes,
  widths,
}) => {
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <MarkdownContext.Provider value={{ classes, widths }}>{children}</MarkdownContext.Provider>
  );
};

export default MarkdownProvider;
